import React from "react";
import { Checkbox } from "antd";
import style from "./style.scss";

const ReversedCheckbox = props => (
  <Checkbox className={style.checkBox} {...props}>
    {props.label}
  </Checkbox>
);

export default ReversedCheckbox;



// WEBPACK FOOTER //
// ./src/components/FormControls/ReversedCheckbox/index.tsx